<template>
  <div>
    <PageTable />
  </div>
</template>

<script>
import PageTable from './components/table'
export default {
  name: 'customerManage-selectionQuotation',
  components: { PageTable },
}
</script>
